import { render } from "./StatusSystem.vue?vue&type=template&id=72bf4322"
import script from "./StatusSystem.vue?vue&type=script&lang=js"
export * from "./StatusSystem.vue?vue&type=script&lang=js"

import "./StatusSystem.vue?vue&type=style&index=0&id=72bf4322&scope=true&lang=css"

import exportComponent from "/Users/bruno/Documents/Codex/bam4-share-link-work/bam4-master/client/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__